export default __webpack_public_path__ + "f722cf1773fb9d69900852b0ec691b9c.png";